import { Api } from "./generated/dax-api/Api";
import { ClosedApi } from "./generated/dax-api/ClosedApi";
import { ApiConfig, RequestParams } from "./generated/dax-api/http-client";
import { ListingDetail } from "./models/ListingDetail";
import { ListingStatusCountFindAllResponse } from "./models/ListingStatusCountFindAllResponse";

export const apiConfig: ApiConfig = {
    baseUrl: '/dax-api'
}

export const daxApi = new Api(apiConfig);
export const daxClosedApi = new ClosedApi(apiConfig);

export const listingDetailFindAll = (listingType: (string|undefined), listingStatus: (string|undefined), params: RequestParams = {}): Promise<ListingDetail[]> => {
    return daxApi.listingDetailFindAllByTenantId<ListingDetail[]>({
        ...(listingType ? {listingType} : {}), 
        ...(listingStatus ? {listingStatus} : {})
    }, params);
}

export const listingDetailById = (id: string, params: RequestParams = {}): Promise<ListingDetail> => {
    return daxApi.listingDetailGetById<ListingDetail>(id, params);
}

export const listingStatusCountFindAll = (listingType: (string|undefined), listingStatus: (string|undefined), params: RequestParams = {}): Promise<ListingStatusCountFindAllResponse[]> => {
    return daxApi.listingStatusCountFindAllByTenantId<ListingStatusCountFindAllResponse[]>({
        ...(listingType ? {listingType} : {}), 
        ...(listingStatus ? {listingStatus} : {})
    }, params);
}
